/**
 * Created by jinxiaomin on 2017/8/17.
 */


export default {
  dealPay: function (type, parameters, callback = function () {}) {

    if (!parameters) {
      console.log('支付参数不能为空')
      return
    }

    if (type) {
      if (type === 'WX') {
       this.dealWXPay(parameters, callback)
      } else if ( type === 'WXH5') {
       this.dealWXH5Pay(parameters)
      } else if (type === 'AliH5') {
       this.dealAliH5Pay(parameters)
      } else {
       console.log('支付类型错误')
      }
    } else {
      console.log('支付类型错误')
    }

  },
  dealWXPay: function (parameters, callback) { // 微信公众号支付

    function wxOnBridgeReady() {
      WeixinJSBridge.invoke(
        'getBrandWCPayRequest', parameters,
        function(res){
          // 使用以上方式判断前端返回,微信团队郑重提示：res.err_msg将在用户支付成功后返回    ok，但并不保证它绝对可靠。
          callback(res)
        }
      )
    }

    if (typeof WeixinJSBridge == "undefined"){
      if( document.addEventListener ){
        document.addEventListener('WeixinJSBridgeReady', wxOnBridgeReady, false);
      }else if (document.attachEvent){
        document.attachEvent('WeixinJSBridgeReady', wxOnBridgeReady);
        document.attachEvent('onWeixinJSBridgeReady', wxOnBridgeReady);
      }
    }else{
      wxOnBridgeReady();
    }

  },
  dealWXH5Pay: function (parameters) { // 微信H5支付唤起微信app
    if (typeof parameters !== 'string') {
      console.log('请传入一个url连接')
    }

    window.location.href = parameters
  },
  dealAliH5Pay: function (parameters) { // 支付宝H5唤起支付宝app
    var div = document.getElementById('aliPayH5')
    // document.body.removeChild(oldDiv)
    if (div == undefined) {
      div = document.createElement('div')
      div.id = 'aliPayH5'
      document.body.appendChild(div)
    }

    div.innerHTML = parameters
    document.forms[0].submit()
  }
}


// WEBPACK FOOTER //
// ./src/js/payHelper.js